import {submitForm} from "../../ajax/form";
import {formatNumber} from "../../../helpers/format-number";
import {format} from "small-date";
import {Order} from "../Order";
import {Section} from "./Section";
import {CartSection} from "./Cart";
import {ShippingSection} from "./Shipping";
import {ProductItem} from "../ProductItem";

export class FinishSection extends Section {

  constructor(sectionElement, loggedIn = false) {
    super(sectionElement);

    FinishSection.element = this.element;
    FinishSection.loggedIn = loggedIn;
  }

  static update() {
    const CONFIRM_DATA = Order.confirmData
    const FINISH_TEXT = document.querySelector('[data-finish="finish-text"]');

    FINISH_TEXT.innerHTML = FINISH_TEXT.innerHTML
      // .replace('$$ORDER_ID', `#${CONFIRM_DATA.orderId}`)
      .replace('$$ORDER_DATE', `${CONFIRM_DATA.orderDate}`)
      .replace('$$CUSTOMER_PRENAME', `${CONFIRM_DATA.address.preName}`)
      .replace('$$CUSTOMER_LASTNAME', `${CONFIRM_DATA.address.lastName}`)

    const ADDRESS_LISTING_ELEMENT = FinishSection.element.querySelector('[data-confirm="address-listing"]');
    Section.updateAddressSection(CONFIRM_DATA.address, ADDRESS_LISTING_ELEMENT);

    const SHIPPING_LISTING_ELEMENT = FinishSection.element.querySelector('[data-confirm="shipping-listing"]');
    Section.updateShippingSection(ShippingSection, CONFIRM_DATA.shipping, SHIPPING_LISTING_ELEMENT)

    const PRODUCTS_ARRAY = Array.from(Order.products);
    const PRODUCT_LISTING_ELEMENT = FinishSection.element.querySelector('[data-confirm="cart-listing"] .products');
    FinishSection.updateProducts(PRODUCTS_ARRAY, PRODUCT_LISTING_ELEMENT, true);

    const DISCOUNT_LISTING_ELEMENT = FinishSection.element.querySelector('[data-confirm="cart-listing"] .discounts');
    Section.updateDiscounts(CartSection, DISCOUNT_LISTING_ELEMENT);

    const SHIPPING_COST_ELEMENT = FinishSection.element.querySelector('[data-confirm="shipping-price"]');
    Section.updateShippingCosts(ShippingSection, CONFIRM_DATA.shipping, SHIPPING_COST_ELEMENT);

    const RETOURE_COST_ELEMENT = FinishSection.element.querySelector('[data-confirm="retoure-price"]');
    Section.updateRetoureCost(ShippingSection, RETOURE_COST_ELEMENT);

    const TOTAL_PRICE_ELEMENT = FinishSection.element.querySelector('[data-confirm="total-price"]');
    Section.updatePriceTotal(CartSection, ShippingSection, TOTAL_PRICE_ELEMENT);
  }

  static updateFinishTextOrderId() {
    const CONFIRM_DATA = Order.confirmData
    const FINISH_TEXT = document.querySelector('[data-finish="finish-text"]');

    FINISH_TEXT.innerHTML = FINISH_TEXT.innerHTML.replace('$$ORDER_ID', `#${CONFIRM_DATA.orderId}`)
  }

  static updateProducts(productsArray, productListingElement, readonly) {
    productListingElement.innerText = '';

    productsArray.forEach(product => {
      const HTML_ELEMENT = product.getHtmlTemplate(readonly);
      productListingElement.append(HTML_ELEMENT)
    })
  }

  static orderData(finalOrderId = '') {
    const CART_DATA = CartSection.priceData;
    const CART_DISCOUNT_DATA = CART_DATA.cartDiscountData;
    const CSRF_FIELD = document.querySelector('[name="csrf_token"]');
    const CONFIRM_DATA = Order.confirmData

    const FINISH_OBJECT = {
      products: [],
      discounts: [],
      shipping: {},
      payment: {},
      address: {},
      orderData: {},
      priceTotal: 0,
      priceToPay: 0,
      loggedIn: FinishSection.loggedIn,
      csrf_token: CSRF_FIELD ? CSRF_FIELD.value : false
    };

    /** CREATE PRODUCT OBJECT*/
    if (Order.products.length <= 0) return false;
    Order.products.forEach(product => {
      const PRODUCT_TEMPLATE = product.pageInfos.productId;

      const PRODUCT_PRICE = ProductItem.getProductPrice(product.configSection.id, product.formDataObject);
      const PRODUCT_PRICE_TOTAL = PRODUCT_PRICE.priceTotal;
      const PRODUCT_PRICE_QUANTITY = PRODUCT_PRICE.quantity;

      const HAS_SPECIALS = product.priceData.hasStrips ||
        product.priceData.hasDouble ||
        product.priceData.luxaflex ||
        product.priceData.hasElectro ||
        product.priceData.hasDuet ||
        product.priceData.hasMold ||
        product.priceData.hasDualFabric ||
        product.priceData.hasPlafond;

      const IS_REPAIR = product.priceData.service === 'repair' || product.priceData.service === 'both';
      const HAS_REPAIR_SURCHARGE = IS_REPAIR ? !!product.priceData.repairExtraWidthSurchargePrice > 0 || product.priceData.repairDualFabricSurchargePrice > 0 : false;

      FINISH_OBJECT.products.push({
        uuid: product.uuid,
        template: PRODUCT_TEMPLATE,
        count: PRODUCT_PRICE_QUANTITY,
        priceTotal: formatNumber(PRODUCT_PRICE_TOTAL),
        width: product.priceData.productWidth.text,
        height: product.priceData.productHeight.text,
        service: product.priceData.service,
        specials: HAS_SPECIALS ? {
          dualFabric: product.priceData.hasDualFabric && product.priceData.dualFabric.surchargeTotal > 0 ? formatNumber(product.priceData.dualFabric.surchargeTotal) : false,
          duet: product.priceData.hasDuet && product.priceData.duet.surchargeTotal > 0 ? formatNumber(product.priceData.duet.surchargeTotal) : false,
          strips: product.priceData.hasStrips && product.priceData.strips.surchargeTotal > 0 ? formatNumber(product.priceData.strips.surchargeTotal) : false,
          double: product.priceData.hasDouble && product.priceData.double.surchargeTotal > 0 ? formatNumber(product.priceData.double.surchargeTotal) : false,
          luxaflex: product.priceData.hasLuxaflex && product.priceData.luxaflex.surchargeTotal > 0 ? formatNumber(product.priceData.luxaflex.surchargeTotal) : false,
          mold: product.priceData.hasMold && product.priceData.mold.surchargeTotal > 0 ? formatNumber(product.priceData.mold.surchargeTotal) : false,
          plafond: product.priceData.hasPlafond && product.priceData.plafond.surchargeTotal > 0 ? formatNumber(product.priceData.plafond.surchargeTotal) : false,
          electro: product.priceData.hasElectro && product.priceData.electro.surchargeTotal > 0 ? formatNumber(product.priceData.electro.surchargeTotal) : false,
        } : false,
        repair: IS_REPAIR ? {
          repairSurcharges: HAS_REPAIR_SURCHARGE ? {
            extraWidth: product.priceData.repairExtraWidthSurchargePrice > 0 ? formatNumber(product.priceData.repairExtraWidthSurchargePrice) : false,
            dualFabric: product.priceData.repairDualFabricSurchargePrice > 0 ? formatNumber(product.priceData.repairDualFabricSurchargePrice) : false,
          } : false,
          repairInfo: product.priceData.repairInfo,
          tensionShoes: product.priceData.tensionShoes,
        } : false
      })
    })

    /** CREATE DISCOUNT OBJECT*/
    for (const [index, discountObject] of Object.entries(CART_DISCOUNT_DATA)) {
      if (discountObject.productDiscountTotal > 0) {
        FINISH_OBJECT.discounts.push({
          template: index,
          priceTotal: formatNumber(discountObject.productDiscountTotal),
          discountTotal: formatNumber(discountObject.productDiscountTotal * -1),
          text: discountObject.discountText
        })
      }
    }

    /** CREATE SHIPPING OBJECT*/
    if (ShippingSection.priceData.currentShippingName === '' || ShippingSection.priceData.currentShippingName === 'undefined') return false;

    const HAS_STRETCH_FILM = ShippingSection.priceData.currentShippingNameKey === 'allInclusive' && ShippingSection.priceData.currentStretchFilms > 0;
    const HAS_PACKAGE_STAMP = ShippingSection.priceData.currentShippingNameKey === 'package';
    const OPTION_WITH_SHIPPING_DATE = ShippingSection.priceData.currentShippingStampKey === 'package_surcharge_gls_pickup' || ShippingSection.priceData.currentShippingStampKey === 'package_surcharge_dhl_pickup'
    const HAS_SHIPPING_DATE = HAS_PACKAGE_STAMP && OPTION_WITH_SHIPPING_DATE

    if (Object.keys(Order.shipping).length === 0 && Order.shipping.constructor === Object) return false;
    FINISH_OBJECT.shipping = {
      shippingOption: {
        id: ShippingSection.priceData.currentShippingNameKey,
        text: ShippingSection.priceData.currentShippingName,
      },

      stretchFilm: HAS_STRETCH_FILM ? {
        text: `${Section.getStretchFilmString(ShippingSection.priceData.currentStretchFilms)}`,
        quantity: ShippingSection.priceData.currentStretchFilms,
        value: formatNumber(ShippingSection.priceData.stretchFilmPrice)
      } : false,

      shippingStamp: HAS_PACKAGE_STAMP ? ShippingSection.priceData.currentShippingStamp : false,

      shippingDate: HAS_SHIPPING_DATE && HAS_SHIPPING_DATE ? Order.shipping.packageDate : false,

      retourePriceTotal: parseInt(ShippingSection.priceData.retourePrice) ? `${formatNumber(ShippingSection.priceData.retourePrice)} €` : ShippingSection.priceData.retourePrice,
      shippingPriceTotal: ShippingSection.priceData.currentShippingPrice > 0 ? formatNumber(ShippingSection.priceData.currentShippingPrice) : false
    }

    /** CREATE PAYMENT OBJECT*/
    FINISH_OBJECT.payment = {
      label: 'Zahlungsart',
      value: 'Rechnung'
    }

    /** CREATE ADDRESS OBJECT*/
    if (Object.keys(Order.address).length === 0 && Order.address.constructor === Object) return false;
    FINISH_OBJECT.address = Order.address;

    if (finalOrderId !== '') {
      FINISH_OBJECT.orderData.orderId = finalOrderId;
      Order.setOrderId(finalOrderId);
    }

    FINISH_OBJECT.orderData.orderDate = format(new Date(), 'dd.MM.yyyy');

    const RETOURE_PRICE_VALUE = parseInt(ShippingSection.priceData.retourePrice) ? parseInt(ShippingSection.priceData.retourePrice) : 0;
    const SHIPPING_PRICE_VALUE = ShippingSection.priceData.currentShippingPrice > 0 ? ShippingSection.priceData.currentShippingPrice : 0;
    const TOTAL_PRICE_TO_PAY = Section.getTotalPriceToPay(CART_DATA.cartPriceToPay, RETOURE_PRICE_VALUE, SHIPPING_PRICE_VALUE)
    FINISH_OBJECT.priceToPay = formatNumber(TOTAL_PRICE_TO_PAY);

    return FINISH_OBJECT;
  }

  static async sendOrder() {
    const ORDER_DATA = FinishSection.orderData;
    const RESPONSE = await submitForm(ORDER_DATA);
    return RESPONSE.json();
  }

}

export const INSTANTIATE_FINISH_SECTION = (isLoggedIn) => {
  const FINISH_SECTION_ELEMENT = document.querySelector('[data-section="finish"]');
  if (!FINISH_SECTION_ELEMENT) return;

  return new FinishSection(FINISH_SECTION_ELEMENT, isLoggedIn);
}
